import { render, staticRenderFns } from "./CardInformacoesCotaCliente.vue?vue&type=template&id=2afc319b&scoped=true&"
import script from "./CardInformacoesCotaCliente.vue?vue&type=script&lang=js&"
export * from "./CardInformacoesCotaCliente.vue?vue&type=script&lang=js&"
import style0 from "./CardInformacoesCotaCliente.vue?vue&type=style&index=0&id=2afc319b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc319b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCardText,VRow,VSkeletonLoader})
